import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { UserProfession } from '~/enums/UserProfession';
import { type IShiftDetailsFormValues } from '../ShiftDetails/ShiftDetailsForm/useShiftDetailsForm';

export const useIsFormValid = () => {
  const { watch } = useFormContext<IShiftDetailsFormValues>();
  const values = watch();

  return useMemo(() => {
    const {
      officeId,
      professionType,
      preferredSpecialty,
      isAssistedHygiene,
      arrivalTime,
      departureTime,
      mealBreakDuration,
      rate,
      dates,
    } = values;

    const professionCode = professionType ? UserProfession.getCode(professionType) : '';
    const isRDH = professionCode === UserProfession.RDH;

    return (
      !!officeId &&
      !!professionType &&
      !!preferredSpecialty &&
      (!isRDH || isAssistedHygiene !== undefined) &&
      !!arrivalTime &&
      !!departureTime &&
      !!mealBreakDuration &&
      rate !== null &&
      dates.length > 0
    );
  }, [values]);
};
